module.exports = __webpack_public_path__ + "static/media/Landscape-Footer.6d3f6b2b.jpg";